import { DROPDOWN } from '@app/core/constants';
import { InsuranceModel, AddedPolicyDataModel } from './model';
import * as _ from "lodash";


// Don't use funtions below because it only right with coverage model
function convertKeysToLabels(questionRaws: any, keys: Array<string>) {
  const labels = [];

  keys.forEach((key, index) => {
    if (key !== 'productCategory' && key === questionRaws[index].key) {
      labels.push(questionRaws[index].label);
    }
  });

  return labels;
}

function convertKeyToValue(
  arrayOptions: { key: string; value: string }[],
  key: string
) {
  let value: string;

  arrayOptions.forEach(item => {
    if (item.key === key) {
      value = item.value;
    }
  });

  return value;
}

function getOptionsFromQuestionRaws(questionRaws: any) {
  let options = [];

  questionRaws.forEach(question => {
    if (question.controlType === DROPDOWN) {
      options = options.concat(question.options);
    }
  });

  return options;
}

function getInsuranceBasedOnKey(insurances: any, key: string): InsuranceModel {
  let insurance = new InsuranceModel();

  insurances.forEach(child => {
    if (child.key === key) {
      insurance = child;
    }
  });

  return insurance;
}

function getSortedInsurancesBasedOnKeys(
  insurances: any,
  orderBy: { key: string; text: string }[]
) {
  const sortedInsurances = [];

  orderBy.forEach(item => {
    sortedInsurances.push(getInsuranceBasedOnKey(insurances, item.key));
  });

  return sortedInsurances;
}

function findIndexOfInsuranceBasedOnKey(insurances: any, key: string) {
  let index = 0;

  index = insurances.findIndex(child => {
    if (child.key === key) {
      return child;
    }
  });

  return index;
}

function isDropdown(questionRaws: any, questionKey: string) {
  let bool = false;

  questionRaws.forEach(question => {
    if (question.key === questionKey && question.controlType === DROPDOWN) {
      bool = true;
    }
  });

  return bool;
}

function getTypeOfQuestion(questionRaws: any, questionKey: string) {
  let type: string;

  questionRaws.forEach(question => {
    if (question.key === questionKey) {
      type = question.type;
    }
  });

  return type;
}

function renderNewPolicyData(insurance: any, questionService: any, questionControlService: any) {
  let data = {};

  const newPolicyDefaultOptions = insurance.newPolicyDefaultOptions;
  const questionaire = questionService.buildCoverageQuestionaire(insurance.questionRaws);
  const form = questionControlService.toFormGroup(questionaire);

  data = {
    key: insurance.key,
    title: insurance.text,
    newPolicyDefaultOptions,
    questionaire,
    form
  };

  return data;
}

function renderAddedPolicyData(insurance: any, indexOfChosenPolicy: number): AddedPolicyDataModel {
  let data = new AddedPolicyDataModel();

  const policy = { ...insurance.policies[indexOfChosenPolicy] };
  delete policy['productCategory'];
  const questionRaws = insurance.questionRaws;
  const keys = Object.keys(policy);
  const labels = convertKeysToLabels(questionRaws, keys).map((label, index) => {
    return { key: keys[index], value: label };
  });

  data = {
    key: insurance.key,
    indexOfChosenPolicy,
    title: insurance.text,
    policy,
    questionRaws,
    labels
  };

  return data;
}

function formatStringToCurrency(amount: string) {
  const buffer = amount.toString().split('.');

  if (!amount) {
    return amount;
  } else if (buffer[1]) {
    amount = buffer[0].replace(/,/g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + '.' + buffer[1];
  } else {
    amount = buffer[0].replace(/,/g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  return amount;
}

function formatCurrencyToString(amount: string) {
  const buffer = amount.toString().split('.');

  if (!amount) {
    return amount;
  } else if (buffer[1]) {
    amount = buffer[0].replace(/,/g, '') + '.' + buffer[1];
  } else {
    amount = buffer[0].replace(/,/g, '');
  }

  return amount;
}

function renderIconPosition(userAge: number) {
  let position = '0%';

  if (userAge <= 18) {
    position = '3.7%';
  } else if (userAge >= 85) {
    position = '92.8%';
  } else if (userAge > 18 && userAge <= 25) {
    position = `${(3.7 + (16.7 - 3.7) / 7 * (userAge - 18)).toFixed(1)}%`;
  } else {
    position = `${(16.7 + 1.25 * (userAge - 25)).toFixed(1)}%`;
  }

  return position;
}


function filterPropertiesOfPolicyDetails(
  questionRaws: any,
  policyDetails: Array<{ key: string, value: string }>,
  filterOption: { key: string, value: string }
) {
  const propertiesFiltered = {};
  questionRaws.forEach(question => {
    if (question.dependsOn && question.dependsOn.value !== filterOption.key) {
      return;
    }

    if (!question.dependsOn) {
      propertiesFiltered[question.key] = policyDetails[question.key];
      return;
    }

    if (question.dependsOn.value === filterOption.key) {
      propertiesFiltered[question.key] = policyDetails[question.key];
    }
  });

  return propertiesFiltered;
}
function onConfigData(question: any) {
  let data: any;
  data = _.map(question, (item => {
    switch (item.KYCQuestionId) {
      case "6098ddf5-5deb-4b83-bba7-54a137a24ba3":
        item.KYCQuestion.Name = "I am currently covered for";
        break;
      case "80d4a0fc-b0a2-4f1c-bc1a-e8e660201f41":
        item.KYCQuestion.Name = "I am interested to know more and be advised for"
        break;
      case "22148f3c-2857-4317-8fc9-223098e92c0b":
        item.KYCQuestion.Name = "I am familiar with"
        break;
      case "6fd14ae0-c8e6-4ffd-a85d-dde679ab6030":
        item.KYCQuestion.Name = "I want my investment to"
        break;
    }
    return { ...item, Answer: false }
  }))
  return data;
}

function onQuestiones(answer, questiones) {
  let result: any;
  result = questiones.map(item => {
    if (item.KYCQuestionId === answer.KYCQuestionId) {
      if (item.Id === answer.Id) {
        item.Answer = !answer.Answer;
      };
    }
  });
  return result
}
function onDefaultAnswerNeeds(arr) {
  _.filter(arr, item => item.KYCQuestion.Order === 6).filter(item => item.Order === 5)[0].Answer = true;
  _.filter(arr, item => item.KYCQuestion.Order === 2).filter(item => item.Order === 3)[0].Answer = true;
  _.filter(arr, item => item.KYCQuestion.Order === 1).filter(item => item.Order === 3)[0].Answer = true;
  _.filter(arr, item => item.KYCQuestion.Order === 7).filter(item => item.Order === 3)[0].Answer = true;
  _.filter(arr, item => item.KYCQuestion.Order === 4).filter(item => item.Order === 5)[0].Answer = true;
  _.filter(arr, item => item.KYCQuestion.Order === 5).filter(item => item.Order === 4)[0].Answer = true;
}

function onCheckAnswer(data) {
  const question_0 = _.filter(data[0], item => item.Answer === true).length !== 0 ? true : false;
  const question_1 = _.filter(data[1], item => item.Answer === true).length !== 0 ? true : false;
  const question_2 = _.filter(data[2], item => item.Answer === true).length !== 0 ? true : false;
  const question_3 = _.filter(data[3], item => item.Answer === true).length !== 0 ? true : false;
  const question_4 = _.filter(data[4], item => item.Answer === true).length !== 0 ? true : false;
  if (question_0 && question_1 && question_2 && question_3 && question_4) {
    return true;
  } else {
    return false;
  }
}
export {
  convertKeysToLabels,
  convertKeyToValue,
  getOptionsFromQuestionRaws,
  getInsuranceBasedOnKey,
  getSortedInsurancesBasedOnKeys,
  findIndexOfInsuranceBasedOnKey,
  isDropdown,
  getTypeOfQuestion,
  renderNewPolicyData,
  renderAddedPolicyData,
  formatStringToCurrency,
  formatCurrencyToString,
  renderIconPosition,
  filterPropertiesOfPolicyDetails,
  onConfigData,
  onQuestiones,
  onDefaultAnswerNeeds,
  onCheckAnswer
};



// WEBPACK FOOTER //
// ./src/app/features/coverage/coverage.ts